/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_JapaneseInputs */



/**
* | output |
* | --- |
* | "Japanese" |
*
* @param {Speechmatics_Target_Language_JapaneseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_japanese = /** @type {((inputs?: Speechmatics_Target_Language_JapaneseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_JapaneseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Japonais")
	if (locale === "de") return /** @type {LocalizedString} */ ("japanisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("giapponese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("японский")
	if (locale === "es") return /** @type {LocalizedString} */ ("japonés")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("日本人")
	if (locale === "ja") return /** @type {LocalizedString} */ ("日本語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जापानी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("japonês")
	return /** @type {LocalizedString} */ ("Japanese")
});